<template>
    <div class="section text-center mt-2" v-if="loading">
        <div class="spinner-border text-primary" role="status"></div>
    </div>

    <template v-else>
        <!-- Track log / timeline -->
        <div class="section mt-1">
            <div class="grq-card">
                <div class="grq-card-title mal-text">അപേക്ഷയുടെ പുരോഗതി</div>
                <div class="grq-timeline">
                    <div class="grq-timeline-line"></div>
                    <div class="grq-timeline-item" v-for="(history, index) in requestData.tracks" :key="history.id">
                        <div class="grq-timeline-dot" :class="statusDotClass(history.status)">
                            <ion-icon name="checkmark-outline"></ion-icon>
                        </div>
                        <div class="grq-timeline-content">
                            <div class="grq-timeline-header">
                                <span class="badge" :class="statusBadgeClass(history.status)">{{ history.status }}</span>
                                <span class="grq-timeline-date">{{ getFormattedDate(history.created_at) }}</span>
                            </div>
                            <div class="grq-timeline-remarks mal-text" v-if="index === 0">{{ requestData.requestDetails.type }}</div>
                            <div class="grq-timeline-remarks">{{ history.remarks }}</div>
                            <div class="grq-timeline-by mal-text" v-if="history.status != 'Request Received'">
                                By {{ history.user_name }} ({{ history.user_level_name }})
                            </div>
                            <div class="grq-timeline-comments mal-text" v-if="history.comments">{{ history.comments }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Request details -->
        <div class="section mt-1">
            <div class="grq-card">
                <div class="grq-card-title mal-text">അപേക്ഷയുടെ വിവരങ്ങൾ</div>

                <div class="grq-detail-row">
                    <span class="grq-detail-label mal-text">എന്തിന് വേണ്ടിയുള്ള അപേക്ഷ</span>
                    <span class="grq-detail-value mal-text">{{ formData.for_what }}</span>
                </div>
                <div class="grq-detail-row" v-if="formData.for_what == 'മറ്റ് കാര്യങ്ങൾക്ക്' && formData.for_what_other">
                    <span class="grq-detail-label mal-text">വിശദാംശം</span>
                    <span class="grq-detail-value mal-text">{{ formData.for_what_other }}</span>
                </div>
                <div class="grq-detail-row" v-if="formData.meeting_date">
                    <span class="grq-detail-label mal-text">യോഗത്തിന്റെ തിയ്യതി</span>
                    <span class="grq-detail-value">{{ formData.meeting_date }}</span>
                </div>
                <div class="grq-detail-row" v-if="formData.minutes_number">
                    <span class="grq-detail-label mal-text">തീരുമാനത്തിന്റെ ക്രമ നമ്പർ</span>
                    <span class="grq-detail-value">{{ formData.minutes_number }}</span>
                </div>
                <div class="grq-detail-row" v-if="requestData.minutes_image">
                    <span class="grq-detail-label mal-text">തീരുമാനത്തിന്റെ ഫോട്ടോ</span>
                    <a class="grq-detail-download" :href="'https://guide.msoftit.com/' + requestData.minutes_image" download="image">
                        <ion-icon name="download-outline"></ion-icon> Download
                    </a>
                </div>

                <template v-if="isExecutiveOrDepartmentOrCancel">
                    <div class="grq-detail-row">
                        <span class="grq-detail-label mal-text">ഒഴിവാക്കേണ്ട ആൾ</span>
                        <span class="grq-detail-value">{{ formData.member }}</span>
                    </div>
                </template>
                <div class="grq-detail-row" v-if="formData.for_what == 'വകുപ്പ് മാറ്റാൻ'">
                    <span class="grq-detail-label mal-text">ഒഴിവാക്കേണ്ട വകുപ്പ്</span>
                    <span class="grq-detail-value">{{ formData.old_department }}</span>
                </div>
                <div class="grq-detail-row" v-if="formData.for_what == 'ഭരവഹിയെ മാറ്റാൻ'">
                    <span class="grq-detail-label mal-text">ഒഴിവാക്കേണ്ട സ്ഥാനം</span>
                    <span class="grq-detail-value">{{ formData.old_duty }}</span>
                </div>

                <div class="grq-detail-row" v-if="formData.for_what == 'ഭരവഹിയെ മാറ്റാൻ' || formData.for_what == 'വകുപ്പ് മാറ്റാൻ'">
                    <span class="grq-detail-label mal-text">പുതുതായി തിരഞ്ഞെടുത്ത ആൾ</span>
                    <span class="grq-detail-value">{{ formData.new_member }}</span>
                </div>
                <div class="grq-detail-row" v-if="formData.for_what == 'വകുപ്പ് മാറ്റാൻ'">
                    <span class="grq-detail-label mal-text">പുതിയ ആൾക്ക് നൽകേണ്ട വകുപ്പ്</span>
                    <span class="grq-detail-value">{{ formData.new_department }}</span>
                </div>
                <div class="grq-detail-row" v-if="formData.for_what == 'ഭരവഹിയെ മാറ്റാൻ'">
                    <span class="grq-detail-label mal-text">പുതിയ ആൾക്ക് നൽകേണ്ട സ്ഥാനം</span>
                    <span class="grq-detail-value">{{ formData.new_duty }}</span>
                </div>

                <template v-if="formData.for_what == 'പുതിയ മെമ്പർഷിപ് ചേർക്കാൻ'">
                    <div class="grq-detail-row">
                        <span class="grq-detail-label mal-text">പേര്</span>
                        <span class="grq-detail-value">{{ formData.name }}</span>
                    </div>
                    <div class="grq-detail-row">
                        <span class="grq-detail-label mal-text">മൊബൈൽ</span>
                        <span class="grq-detail-value">{{ formData.mobile }}</span>
                    </div>
                    <div class="grq-detail-row">
                        <span class="grq-detail-label mal-text">വാട്സ്ആപ്പ്</span>
                        <span class="grq-detail-value">{{ formData.whatsapp }}</span>
                    </div>
                    <div class="grq-detail-row">
                        <span class="grq-detail-label mal-text">വിങ്</span>
                        <span class="grq-detail-value">{{ formData.wing }}</span>
                    </div>
                </template>
            </div>
        </div>

        <div class="section mt-1 mb-2" v-if="responseData.permissions.action">
            <button type="button" data-bs-toggle="modal" data-bs-target="#actionSheetInset"
                class="btn btn-primary btn-block btn-lg" :disabled="btnLoading">
                <span v-show="btnLoading" class="spinner-border spinner-border-sm"></span>
                <span>Action</span>
            </button>
        </div>
    </template>

    <!-- Default Action Sheet Inset -->
    <div class="modal fade action-sheet" id="actionSheetInset" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Action</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <button type="button" class="grq-option-btn"
                            v-if="canForward"
                            @click="showActionForm(1)" data-bs-dismiss="modal">
                            <div class="grq-option-icon-circle grq-option-icon-circle--blue"><ion-icon name="arrow-forward-outline"></ion-icon></div>
                            <span>Forward</span>
                        </button>
                        <button type="button" class="grq-option-btn"
                            v-if="canReceiveAsGuideAdmin"
                            @click="showActionForm(3, 'guide')" data-bs-dismiss="modal">
                            <div class="grq-option-icon-circle grq-option-icon-circle--blue"><ion-icon name="arrow-forward-outline"></ion-icon></div>
                            <span>Receive Request As Guide Admin</span>
                        </button>
                        <button type="button" class="grq-option-btn"
                            v-if="canChangeStatus"
                            @click="showStatusActionForm()" data-bs-dismiss="modal">
                            <div class="grq-option-icon-circle grq-option-icon-circle--green"><ion-icon name="checkmark-done-outline"></ion-icon></div>
                            <span>Change Status</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Forward / receive comment modal -->
    <div class="modal fade action-sheet" id="actionModel" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ action_btn_text }}</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <div class="form-group basic">
                            <label class="label" for="action_comments"><span>Comments</span></label>
                            <textarea id="action_comments" class="form-control" rows="4" v-model="action_comments"></textarea>
                        </div>
                        <div class="form-group basic">
                            <button type="button" @click="action()" class="btn btn-primary btn-block btn-lg" :disabled="loading">
                                <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                <span>{{ action_btn_text }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Change status modal -->
    <div class="modal fade action-sheet" id="statusActionModel" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Status Change</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <div class="form-group basic">
                            <div class="input-wrapper">
                                <label class="label text-primary" for="status">
                                    Status <span class="text-danger">*</span>
                                </label>
                                <select class="form-control custom-select" v-model="status" id="status">
                                    <option value>---Select---</option>
                                    <option value="Rejected">Rejected</option>
                                    <option value="Pending">Pending</option>
                                    <option value="Completed">Completed</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group basic">
                            <label class="label text-primary" for="status_comments"><span>Comments</span></label>
                            <textarea id="status_comments" class="form-control" rows="4" v-model="action_comments"></textarea>
                        </div>
                        <div class="form-group basic">
                            <button type="button" @click="action('change_status')" class="btn btn-primary btn-block btn-lg" :disabled="loading">
                                <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                <span>Save</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
</template>

<script>
import UserService from "../../services/user.service";
import AlertModel from "../layouts/AlertModel.vue";
import moment from 'moment'
import $ from 'jquery';

const WING_LABELS = { 1: 'Wisdom', 2: 'Youth', 3: 'Students', 4: 'Women', 5: 'Balavedi', 6: 'Girls' };

export default {
    name: 'RequestView',
    components: {
        AlertModel,
    },
    data() {
        return {
            loading: false,
            btnLoading: false,
            alert_type: '',
            alert_message: '',
            formData: {
                for_what: '',
                for_what_other: '',
                meeting_date: '',
                minutes_number: '',
                member: '',
                old_department: '',
                new_department: '',
                old_duty: '',
                new_duty: '',
                new_member: '',
                name: '',
                mobile: '',
                whatsapp: '',
                wing: '',
            },
            responseData: {
                permissions: {},
            },
            requestData: {
                tracks: [],
                requestDetails: {},
            },
            action_comments: '',
            action_btn_text: '',
            status: '',
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        isExecutiveOrDepartmentOrCancel() {
            return ['ഭരവഹിയെ മാറ്റാൻ', 'വകുപ്പ് മാറ്റാൻ', 'മെമ്പർഷിപ്പ് ഒഴിവാക്കാൻ'].includes(this.formData.for_what);
        },
        lastTrack() {
            const tracks = this.requestData.tracks || [];
            return tracks.length ? tracks[tracks.length - 1] : null;
        },
        canForward() {
            return this.responseData.permissions.action
                && parseInt(this.$route.params.sub_level) > 0
                && this.lastTrack
                && this.lastTrack.forwarded_to_level > 0;
        },
        canReceiveAsGuideAdmin() {
            return this.responseData.permissions.action
                && parseInt(this.$route.params.sub_level) === 0
                && this.responseData.permissions.guide_permission
                && this.lastTrack
                && this.lastTrack.status != 'Request Received';
        },
        canChangeStatus() {
            return this.responseData.permissions.action
                && parseInt(this.$route.params.sub_level) === 0
                && this.responseData.permissions.guide_permission
                && this.lastTrack
                && this.lastTrack.status == 'Request Received';
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace('/');
            return;
        }
        this.$root.updateParent("Loading...");
        this.getRequest(this.$route.params.request_id);
    },
    methods: {
        getFormattedDate(date) {
            return moment(date).format("DD-MM-YYYY");
        },
        statusBadgeClass(status) {
            if (status === 'Request Completed') return 'bg-success';
            if (status === 'Request Received') return 'bg-info text-dark';
            if (status === 'Request Rejected') return 'bg-danger';
            if (status === 'Request Pending') return 'bg-warning text-dark';
            return 'bg-primary';
        },
        statusDotClass(status) {
            if (status === 'Request Completed') return 'grq-timeline-dot--success';
            if (status === 'Request Rejected') return 'grq-timeline-dot--danger';
            if (status === 'Request Pending') return 'grq-timeline-dot--warning';
            return 'grq-timeline-dot--primary';
        },
        getRequest(id) {
            this.loading = true;
            UserService.authPostRequest('get-request', { id }).then(
                (response) => {
                    this.loading = false;
                    if (response.data.status == 'success') {
                        this.$root.updateParent("Request");
                        this.responseData = response.data.data;
                        this.requestData = response.data.data.list;
                        this.formData.for_what = this.requestData.sub_type;
                        this.formData.for_what_other = this.requestData.other_request;
                        this.formData.meeting_date = this.requestData.meeting_date;
                        this.formData.minutes_number = this.requestData.minutes_number;

                        if (this.requestData.member_to_change && this.requestData.member_to_change.member) {
                            this.formData.member = this.requestData.member_to_change.member.name + ' - ' + this.requestData.member_to_change.member.mobile;
                        }
                        if (this.requestData.new_member_to_change && this.requestData.new_member_to_change.member) {
                            this.formData.new_member = this.requestData.new_member_to_change.member.name + ' - ' + this.requestData.new_member_to_change.member.mobile;
                        }

                        if (this.requestData.departments_to_change) {
                            this.formData.old_department = this.requestData.old_dep;
                        }
                        if (this.requestData.new_departments_to_change) {
                            this.formData.new_department = this.requestData.new_dep;
                        }
                        if (this.requestData.designations_to_change) {
                            this.formData.old_duty = this.requestData.old_duty;
                        }
                        if (this.requestData.new_designations_to_change) {
                            this.formData.new_duty = this.requestData.new_duty;
                        }

                        if (this.requestData.name) {
                            this.formData.name = this.requestData.name;
                            this.formData.mobile = this.requestData.country_code + ' ' + this.requestData.mobile;
                            this.formData.whatsapp = this.requestData.country_code_whatsapp + this.requestData.whatsapp;
                            this.formData.wing = WING_LABELS[this.requestData.wing] || '';
                        }
                    }
                },
                (error) => {
                    this.loading = false;
                    this.alert_type = 'Error';
                    this.alert_message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
                    this.$refs.alert_model.openModel();
                }
            );
        },
        showActionForm(type) {
            this.action_btn_text = type == 1 ? 'Forward' : (type == 2 ? 'Reject' : 'Accept Changes');
            this.action_comments = '';
            $('#actionModel').modal('show');
        },
        showStatusActionForm() {
            this.status = '';
            this.action_comments = '';
            $('#statusActionModel').modal('show');
        },
        action(type = null) {
            this.loading = true;
            UserService.addAdmin('store-request-action', {
                user_level: parseInt(this.$route.params.sub_level),
                user_level_id: parseInt(this.$route.params.id),
                id: this.requestData.id,
                comments: this.action_comments,
                status: this.status,
                type: type ? type : 'forward',
            }).then(
                (response) => {
                    this.loading = false;
                    if (response.data.status == 'success') {
                        $('#actionModel').modal('hide');
                        $('#statusActionModel').modal('hide');
                        this.getRequest(this.requestData.id);
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                    } else {
                        this.alert_type = response.data.status === 'warning' ? 'Warning' : 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                    }
                },
                (error) => {
                    this.loading = false;
                    this.alert_type = 'Error';
                    this.alert_message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
                    this.$refs.alert_model.openModel();
                }
            );
        },
    },
};
</script>

<style scoped>
.grq-card {
    background: #fff;
    border-radius: 12px;
    padding: 14px 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.grq-card-title {
    font-size: 0.95rem;
    font-weight: 700;
    color: #27173E;
    margin-bottom: 12px;
}

/* Timeline */
.grq-timeline {
    position: relative;
}

.grq-timeline-line {
    position: absolute;
    left: 15px;
    top: 4px;
    bottom: 4px;
    width: 2px;
    background: #e2e8f0;
}

.grq-timeline-item {
    display: flex;
    gap: 12px;
    position: relative;
    margin-bottom: 18px;
}

.grq-timeline-item:last-child {
    margin-bottom: 0;
}

.grq-timeline-dot {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 16px;
    z-index: 1;
    border: 3px solid #fff;
    box-shadow: 0 0 0 1px #e2e8f0;
}

.grq-timeline-dot--primary { background: #1a418c; }
.grq-timeline-dot--success { background: #12a85a; }
.grq-timeline-dot--danger { background: #d9534f; }
.grq-timeline-dot--warning { background: #d9a441; }

.grq-timeline-content {
    flex: 1;
    min-width: 0;
    padding-top: 2px;
}

.grq-timeline-header {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    margin-bottom: 4px;
}

.grq-timeline-date {
    font-size: 0.76rem;
    color: #94a3b8;
}

.grq-timeline-remarks {
    font-size: 0.86rem;
    color: #27173E;
    font-weight: 600;
    line-height: 1.4;
}

.grq-timeline-by {
    font-size: 0.78rem;
    color: #6c757d;
    margin-top: 2px;
}

.grq-timeline-comments {
    font-size: 0.8rem;
    color: #495057;
    margin-top: 4px;
    background: #f8f9fa;
    border-radius: 6px;
    padding: 6px 8px;
}

/* Detail rows */
.grq-detail-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 10px;
    padding: 9px 0;
    border-top: 1px solid #f3f4f8;
}

.grq-detail-row:first-of-type {
    border-top: none;
}

.grq-detail-label {
    font-size: 0.8rem;
    color: #6c757d;
    flex-shrink: 0;
    max-width: 55%;
}

.grq-detail-value {
    font-size: 0.86rem;
    font-weight: 600;
    color: #27173E;
    text-align: right;
    word-break: break-word;
}

.grq-detail-download {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 0.85rem;
    font-weight: 600;
    color: #1a418c;
    text-decoration: none;
}

/* Action sheet option list */
.grq-option-btn {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    border: none;
    background: transparent;
    padding: 12px 4px;
    text-align: left;
    font-size: 0.92rem;
    font-weight: 600;
    color: #27173E;
    border-bottom: 1px solid #f0f0f0;
}

.grq-option-btn:last-child {
    border-bottom: none;
}

.grq-option-icon-circle {
    flex-shrink: 0;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: #fff;
}

.grq-option-icon-circle--blue { background: #1a418c; }
.grq-option-icon-circle--green { background: #12a85a; }
</style>
